import React from 'react';
import { m } from 'framer-motion';
import { CreditCardIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { trackMetaEvent } from '../../utils/metaPixel';
const trustItems = [{
  icon: CreditCardIcon,
  label: 'Pago único'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}];
export function PriceReveal() {
  return <section id="oferta" className="bg-cream-dark py-10 sm:py-14" data-id="element-105" data-mp="vg7wgq0zflmk">
      <div className="mx-auto max-w-xl px-4 text-center sm:px-6" data-id="element-106" data-mp="10f2h7xiifk9b">
        <p className="font-heading text-lg font-semibold text-navy sm:text-xl" data-id="element-107" data-mp="lpwi09jo9u1f">
          Hoy, el sistema completo cuesta:
        </p>

        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="mt-6 rounded-3xl border border-orange/40 bg-white p-6 shadow-card sm:p-8" data-id="element-108" data-mp="qny28xsu3zeh">
          <p className="text-sm text-muted" data-id="element-109" data-mp="u3i30m9tbgw6">
            Valor real: <span className="line-through" data-id="element-110" data-mp="u1x8gwnhzxyb">240€</span>
          </p>
          <p className="mt-1 font-heading text-6xl font-extrabold text-orange-hover sm:text-7xl" data-id="element-111" data-mp="p6866lk3g2yb">19€</p>
          <p className="mt-3 text-sm leading-relaxed text-ink sm:text-base" data-id="element-112" data-mp="12xwj2r262vgc">
            Acceso inmediato a todos los tomos y bonos. De por vida.
          </p>

          <div className="mt-6" data-id="element-113" data-mp="1ctzvcpqqgah0">
            <PrimaryButton fullWidth size="lg" onClick={() => trackMetaEvent('InitiateCheckout', {
            value: 19,
            currency: 'EUR'
          })} data-id="element-114" data-mp="1ct82vnsfmsuy">
              Acceso Ahora — 19€
            </PrimaryButton>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted" data-id="element-115" data-mp="1ht2rfkoqj6cu">
            {trustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-116" data-mp="3nn2ne8fjuv51">
                <item.icon size={12} data-id="element-117" data-mp="3jm0ndpdt6f20" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}